export default {
	full: ['no-results--full-size']
};
